import * as React from 'react'
import BaseTimeSuggestionOverview, { BaseTimeSuggestionOverviewProps } from './BaseTimeSuggestionOverview'

export default function GlobalTimeSuggestionOverview(props: BaseTimeSuggestionOverviewProps) {
    return <BaseTimeSuggestionOverview {...props} localStorageKeyPrefix={'HammockGlobalTimeSuggestionOverview'} />
}
